import * as i0 from '@angular/core';
import * as i1 from './module';
import * as i2 from './component';
import * as i3 from './directive';
export const AceEditorModuleNgFactory:i0.NgModuleFactory<i1.AceEditorModule> = (null as any);
var _decl0_0:i2.AceEditorComponent = (<any>(null as any));
var _decl0_1:i3.AceEditorDirective = (<any>(null as any));
var _decl0_2:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_3:i0.ElementRef<any> = (<any>(null as any));
function _View_AceEditorComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_AceEditorComponent_1_0():void {
  var _any:any = (null as any);
}
